
/* injects from baggage-loader */

'use strict';

import AccountSettingsPaymentsComponent from './account.settings.payments.component';

const AccountSettingsPaymentsPageModule = angular.module('account-settings-payments-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('account.settings.payments', {
        url: '/payments',
        component: 'accountSettingsPayments',
        // Requires valid login to visit
        protected: true,
        // Resolve promises into controller bindings, see component for bindings
        resolve: { 
          stripeAccount: function(Parse) {
            return Parse.Cloud.run('fetchStripeCustomer');
          }
        }
      });
  })
  .component('accountSettingsPayments', new AccountSettingsPaymentsComponent());

export default AccountSettingsPaymentsPageModule;



// WEBPACK FOOTER //
// ./src/app/pages/account/settings/payments/account.settings.payments.module.js